import { render, staticRenderFns } from "./IntegralGoods.vue?vue&type=template&id=3bf7f3a7&scoped=true&"
import script from "./IntegralGoods.vue?vue&type=script&lang=js&"
export * from "./IntegralGoods.vue?vue&type=script&lang=js&"
import style0 from "./IntegralGoods.vue?vue&type=style&index=0&id=3bf7f3a7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf7f3a7",
  null
  
)

export default component.exports